import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faUser, faArrowRight, faEnvelope ,faFilePdf} from '@fortawesome/free-solid-svg-icons';
import Header from '../Header';
import {
  Button, Table, Alert, Spinner, Card,
  Container, Row, Col, Modal, Form, Pagination
} from 'react-bootstrap';
import './index.css';

const LeadsList = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [showGSTModal, setShowGSTModal] = useState(false);
  const [hasGST, setHasGST] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [gstError, setGstError] = useState('');
  const [services, setServices] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [metaMessage, setMetaMessage] = useState('');
  const [legalName, setLegalName] = useState('');
  const [fetchingLegalName, setFetchingLegalName] = useState(false);

  const [lead, setLead] = useState({
    company: '', name: '', address: '', source: '', service: '',
    plan: '', customPlan: '', totalAmount: '', remarks: '', date: ''
  });

  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const leadsPerPage = 10;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/leads');
        const data = await response.json();
        if (Array.isArray(data.leads)) {
          setLeads(data.leads || []);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchLeads();
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/getservices');
        const data = await response.json();
        setServices(data || []);
      } catch {
        setError('Error fetching services.');
      }
    };
    fetchServices();
  }, []);

  const handleServiceChange = async (e) => {
    const selectedService = e.target.value;
    setLead(prev => ({ ...prev, service: selectedService, plan: '', customPlan: '' }));
    if (selectedService) {
      setLoadingPlans(true);
      try {
        const response = await fetch(`https://apiaksharaconnect.aksharafinalytics.in/getplans/${selectedService}`);
        const data = await response.json();
        setPlans(data || []);
      } catch {
        setError('Error fetching plans for the selected service.');
      } finally {
        setLoadingPlans(false);
      }
    } else {
      setPlans([]);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLead(prev => ({ ...prev, [name]: value }));
  };

  const handleAction = (action, id) => {
    const leadToConvert = leads.find(lead => lead.id === id);

    if (action === 'edit') {
      navigate(`/edit-lead/${id}`);

    } else if(action === 'sms'){
      navigate(`/communication/${id}`);

    } else if (action === 'brochuer') {
      fetch(`https://apiaksharaconnect.aksharafinalytics.in/Watidoc/${id}`, {
          method: 'POST',
        })
        .then((response) => {
          if (response.ok ) {
            setLeads(prevLeads => prevLeads.filter((lead) => lead.id !== id));
              setSuccessMessage('Brochuer Sent Successfully.');
          } else {
            return response.json().then((errorData) => {
              throw new Error(errorData.message || 'Failed to send brochuer');
            });
          }
        })
        .catch((error) => {
          alert(`Error Sending Brochuer lead: ${error.message}`);
        });

    } else if (action === 'delete') {
      const confirmDelete = window.confirm('Are you sure you want to delete this lead?');
      if (confirmDelete) {
        fetch(`https://apiaksharaconnect.aksharafinalytics.in/delete_lead/${id}`, {
          method: 'DELETE',
        })
          .then((response) => {
            if (response.ok) {
              setLeads(prevLeads => prevLeads.filter((lead) => lead.id !== id));
              alert('Lead deleted successfully');
            } else {
              return response.json().then((errorData) => {
                throw new Error(errorData.message || 'Failed to delete lead');
              });
            }
          })
          .catch((error) => {
            alert(`Error deleting lead: ${error.message}`);
          });
      }
    } else if (action === 'convert') {
      setSelectedLead(leadToConvert);
      setLead({
        company: leadToConvert.company || '',
        name: leadToConvert.name || '',
        address: leadToConvert.address || '',
        phone: leadToConvert.phone || '',
        email: leadToConvert.email || '',
        source: leadToConvert.source || '',
        service: '',
        plan: '',
        customPlan: '',
        totalAmount: '',
        remarks: '',
        date: '',
      });
      setShowGSTModal(true);
    }
  };

  const validateGST = (gst) => {
    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return gstRegex.test(gst.toUpperCase());
  };

  const convertLead = async () => {
  setShowGSTModal(false);
  const payload = {
    lead_id: selectedLead?.id,
    company: lead.company,
    name: lead.name,
    phone: lead.phone,
    email: lead.email,
    address: lead.address,
    source: lead.source,
    reg_gst: hasGST === 'Yes' ? 'yes' : 'no',
    gst_number: lead.gstin || '',
    service: lead.service,
    plan: lead.plan,
    customPlan: lead.customPlan,
    remarks: lead.remarks,
    totalAmount: lead.totalAmount,
    dor: lead.date,
    leadby: selectedLead?.EmpName || selectedLead?.leadby,
  };

  console.log("Submitting the following lead conversion data:", JSON.stringify(payload, null, 2));


  try {
    const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/convert', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    const result = await response.json();
    if (response.ok && result.status === 'success') {
      setSuccessMessage(result.message || 'Converted successfully.');
      // setTimeout(() => window.location.reload(), 3000);
    } else if (result.status === 'error') {
      setError(result.message || 'Conversion failed.');
    }
  } catch (error) {
    alert(`Error: ${error.message}`);
  }
};


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  const filteredLeads = leads.filter(lead =>
    (lead.namesss || lead.leadby || '').toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastLead = currentPage * leadsPerPage;
  const indexOfFirstLead = indexOfLastLead - leadsPerPage;
  const currentLeads = filteredLeads.slice(indexOfFirstLead, indexOfLastLead);
  const totalPages = Math.ceil(filteredLeads.length / leadsPerPage);

  const exportToCSV = () => {
    const headers = [
      'Name', 'Email', 'Phone', 'WhatsApp', 'Address',
      'Source', 'Lead By', 'Date', 'Status'
    ];

    const rows = filteredLeads.map(lead => [
      lead.name || '',
      lead.email || '',
      lead.phone || '',
      lead.whatsapp || '',
      lead.address || '',
      lead.source || '',
      lead.EmpName || lead.leadby || '',
      formatDate(lead.lead_date),
      lead.status || '',
    ]);

    const csvContent = [headers, ...rows]
      .map(row => row.map(value => `"${value}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'leads_export.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

const fetchMetaLeads = async () => {
  setLoading(true);
  try {
    const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/fetch-leads');
    const contentType = response.headers.get("content-type");

    if (!response.ok) {
      const errorText = contentType && contentType.includes("application/json")
        ? await response.json()
        : await response.text();
      throw new Error(errorText.message || errorText || `Error: ${response.status}`);
    }

    const data = contentType && contentType.includes("application/json")
      ? await response.json()
      : await response.text();

    console.log('Meta leads fetched:', data);
    setMetaMessage(data);
  } catch (error) {
    console.error('Error fetching meta leads:', error);
    setMetaMessage(`Failed to fetch meta leads: ${error.message}`);
  } finally {
    setLoading(false);
  }

  setTimeout(() => setMetaMessage(''), 10000);
};



 const fetchLegalNameFromGST = async (gstin) => {
  setFetchingLegalName(true);
  try {
    const formBody = new URLSearchParams();
    formBody.append('gstin', gstin);

    const response = await fetch('https://apiaksharaconnect.aksharafinalytics.in/gstdetails', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formBody.toString(),
    });

    const result = await response.json();

    if (result.status === 'success' && result.data?.lgnm) {
      const legalNameFromAPI = result.data.lgnm;

      const addr = result.data.pradr?.addr || {};
      const formattedAddress = [
        addr.bnm,
        addr.loc,
        addr.st,
        addr.dst,
        addr.stcd,
        addr.pncd,
      ]
        .filter(Boolean)
        .join(', ');

      setLegalName(legalNameFromAPI);
      setLead(prev => ({
        ...prev,
        company: legalNameFromAPI,
        address: formattedAddress,
      }));

      setGstError('');
    } else {
      setLegalName('');
      setLead(prev => ({ ...prev, address: '' }));
      setGstError('Legal name not found for this GST.');
    }
  } catch (error) {
    setLegalName('');
    setLead(prev => ({ ...prev, address: '' }));
    setGstError('Failed to fetch legal name.');
  } finally {
    setFetchingLegalName(false);
  }
};





  if (loading) {
    return <div className="text-center"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <>
      <Header />
      <Container fluid className="shadow mx-1 px-3 bg-light rounded-3">
        <Row className="d-flex align-items-center justify-content-between p-3 mt-3">
          <Col><h4 className="mb-0">Lead Management</h4></Col>
          <Col className="text-end">
            <Button variant="info"  className="me-2" onClick={fetchMetaLeads} disabled={loading}>
              {loading ? 'Loading...' : 'Meta Leads'}
            </Button>
            <Button variant="primary" className="me-2" onClick={() => navigate('/Lead')}>Add Lead</Button> 
            <Button variant="danger" onClick={() => navigate('/DeleteLeads')}>Deleted Leads</Button>
          </Col>
        </Row>
        <hr />

        {successMessage && <Alert variant="success">{successMessage}</Alert>}
        {error && <Alert variant="danger">{error}</Alert>}
        {metaMessage && <Alert variant="info">{metaMessage}</Alert>}

        <Row className="px-3 mb-3">
          <Col md={4}>
            <Form.Control
              type="text"
              placeholder="Search by Lead By..."
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </Col>
          <Col md="auto">
            <Button variant="success" onClick={exportToCSV}>Export to CSV</Button>
          </Col>
        </Row>

        <Card>
          <Card.Header>Lead List</Card.Header>
          <Card.Body>
            <Table  bordered hover>
              <thead>
                <tr>
                  <th>S.no</th>
                  <th>User</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Source</th>
                  <th>Lead By</th>
                  <th>Remarks</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentLeads.length > 0 ? currentLeads.map((lead, index) => (
                  <tr key={lead.id}>
                    <td>{indexOfFirstLead + index + 1}</td>
                    <td>{lead.name || 'N/A'}</td>
                    <td>{lead.email || 'N/A'}</td>
                    <td>{lead.phone || 'N/A'}</td>
                    <td>{lead.source || 'N/A'}</td>
                    <td>{lead.EmpName || lead.leadby}</td>
                    <td>{lead.remarks || 'N/A'}</td>
                    <td>{formatDate(lead.lead_date)}</td>
                    <td style={lead.status === 'Closed' ? { color: 'green' } : lead.status === 'in-progress' ? { color: '#fff', textAlign: 'center', backgroundColor: 'coral' } : { color: '#fff', textAlign: 'center', backgroundColor: '#02ace6' }}>
                      {lead.status || 'Unknown'}
                    </td>

                    <td>
                      <Button variant="warning" size="sm" onClick={() => handleAction('edit', lead.id)} disabled={lead.status === 'converted'} title="Edit">
                        <FontAwesomeIcon icon={faEdit} />
                      </Button>
                      <Button variant="danger" size="sm" className="ms-2" onClick={() => handleAction('delete', lead.id)} disabled={lead.status === 'converted'} title="Delete">
                        <FontAwesomeIcon icon={faTrashAlt} />
                      </Button>
                      <Button variant="success" size="sm" className="ms-2" onClick={() => handleAction('convert', lead.id)} disabled={lead.status === 'converted'} title="Convert">
                        <FontAwesomeIcon icon={faUser} />
                        <FontAwesomeIcon icon={faArrowRight} />
                      </Button>
                       <Button variant="dark" size="sm" className='m-2' onClick={() => handleAction('sms', lead.id)} disabled={lead.status === 'converted'} title="sms">
                        <FontAwesomeIcon icon={faEnvelope } />
                      </Button>
                      <Button variant="dark" size="sm" onClick={() => handleAction('brochuer', lead.id)} disabled={lead.status === 'converted'} title="brochuer">
                        <FontAwesomeIcon icon={faFilePdf } />
                      </Button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="11">No leads available</td></tr>
                )}
              </tbody>
            </Table>

            {totalPages > 1 && (
              <Pagination className="justify-content-center mt-3">
                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
                {[...Array(totalPages)].map((_, idx) => (
                  <Pagination.Item
                    key={idx + 1}
                    active={currentPage === idx + 1}
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
                <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
              </Pagination>
            )}
          </Card.Body>
        </Card>

        {/* GST Modal */}
        <Modal show={showGSTModal} onHide={() => setShowGSTModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Lead Conversion</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Do you have a GST number?</Form.Label>
                <Form.Select
                  value={hasGST}
                  onChange={(e) => {
                    setHasGST(e.target.value);
                    setGstError('');
                    if (e.target.value === 'No') {
                      setGstNumber('');
                      setLegalName('');
                    }
                  }}
                >
                  <option value="">Select Option</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
              </Form.Group>

              {hasGST === 'Yes' && (
                <>
                  <Form.Group className="mb-3" controlId="formGSTNumber">
                    <Form.Label>GST Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="gstin"
                      placeholder="Enter GST Number"
                      value={lead.gstin}
                      onChange={(e) => {
                        const value = e.target.value.toUpperCase();
                        setLead(prev => ({ ...prev, gstin: value }));

                        if (validateGST(value)) {
                          setGstError('');
                          fetchLegalNameFromGST(value);
                        } else {
                          setLegalName('');
                          setGstError(value ? 'Invalid GST number format.' : '');
                        }
                      }}
                      isInvalid={!!gstError}
                      maxLength={15} // GST number length
                    />
                    <Form.Control.Feedback type="invalid">
                      {gstError}
                    </Form.Control.Feedback>
                  </Form.Group>

                   <Form.Group className="mb-3 mt-2">
                    <Form.Label>Company Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="company"
                      value={lead.company}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group>
      <Form.Label>Address</Form.Label>
      <Form.Control
        type="text"
        name="address"
        value={lead.address}
        onChange={handleChange}
      />
    </Form.Group>
                </>
              )}

             

              <Form.Group className="mb-3">
                <Form.Label>Service</Form.Label>
                <Form.Control
                  as="select"
                  name="service"
                  value={lead.service}
                  onChange={handleServiceChange}
                  required
                >
                  <option value="">-- Select Service --</option>
                  {loadingPlans ? (
                    <option disabled>Loading...</option>
                  ) : (
                    services.map(service => (
                      <option key={service.id} value={service.id}>
                        {service.name}
                      </option>
                    ))
                  )}
                </Form.Control>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Plan</Form.Label>
                <Form.Control
                  as="select"
                  name="plan"
                  value={lead.plan}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Select Plan --</option>
                  {plans.map(plan => (
                    <option key={plan.id} value={plan.id}>
                      {plan.name} - ₹{plan.price}
                    </option>
                  ))}
                </Form.Control>
              </Form.Group>

              {lead.plan === '42' && (
                <Form.Group className="mb-3">
                  <Form.Label>Other Service</Form.Label>
                  <Form.Control
                    type="text"
                    name="customPlan"
                    value={lead.customPlan}
                    onChange={handleChange}
                  />
                </Form.Group>
              )}

              <Form.Group className="mb-3">
                <Form.Label>Total Amount</Form.Label>
                <Form.Control
                  type="number"
                  name="totalAmount"
                  value={lead.totalAmount}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Remarks</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="remarks"
                  value={lead.remarks}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  name="date"
                  value={lead.date}
                  onChange={handleChange}
                  required
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowGSTModal(false)}>
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                // if (hasGST === 'Yes' && !validateGST(gstNumber)) {
                //   setGstError('Invalid GST number format.');
                //   return;
                // }
                convertLead();
              }}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

      </Container>
    </>
  );
};

export default LeadsList;
